import { render } from "./GrowthRecords.vue?vue&type=template&id=3069a7cc&ts=true"
import script from "./GrowthRecords.vue?vue&type=script&lang=ts"
export * from "./GrowthRecords.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__